"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Article = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));

var _uxcore = require("@ux/uxcore2");

var _Style = _interopRequireDefault(require("../components/Style"));

var _constants = require("../constants");

var _actions = require("../store/actions");

var _articles = require("../store/reducers/articles");

var _styles = _interopRequireDefault(require("../styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Article =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Article, _PureComponent);

  function Article(props) {
    var _this;

    _classCallCheck(this, Article);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Article).call(this, props));
    _this.state = {
      error: '',
      hasError: false
    };
    return _this;
  }

  _createClass(Article, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error
    /* , info */
    ) {
      this.setState({
        error: error,
        hasError: true
      });
    }
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.fetch();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.fetch();

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidUpdate() {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "fetch",
    value: function () {
      var _fetch = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var id;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                id = this.props.match.params.id;

                if (this.props.article) {
                  _context3.next = 4;
                  break;
                }

                _context3.next = 4;
                return this.props.articleGet(id);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetch() {
        return _fetch.apply(this, arguments);
      }

      return fetch;
    }()
  }, {
    key: "handleArticleLinkClicked",
    value: function handleArticleLinkClicked(articleId) {
      this.props.trafficArticleClick({
        articleId: articleId,
        from: 'article'
      });
    }
  }, {
    key: "handleArticleViewed",
    value: function handleArticleViewed() {
      var article = this.props.article;
      var hasError = this.state.hasError;

      if (!hasError && article) {
        this.props.trafficArticleView({
          articleId: article.id
        });
      }
    }
  }, {
    key: "renderArticleFromHTML",
    value: function renderArticleFromHTML(html) {
      var _this2 = this;

      return (0, _htmlReactParser.default)(html, {
        replace: function replace(node) {
          if (node.name === 'a' && node.attribs) {
            if (node.attribs.href) {
              node.attribs.target = '_blank';
              node.attribs.rel = 'noopener noreferrer';
              var href = node.attribs.href.replace('${hostPath}', _constants.HOST_PATH);
              node.attribs.href = href;
              var anchorTitle = node.children[0] && node.children[0].data;
              if (!anchorTitle) return null;
              var articleIdRegex = /\${articleId=(.*)}/g;
              var articleIdMatches = articleIdRegex.exec(href);
              var articleId = articleIdMatches && articleIdMatches[1] || null;

              if (articleId) {
                return _react.default.createElement(_reactRouterDom.Link, {
                  className: "help--article-content-link",
                  to: "/article/".concat(articleId),
                  onClick: function onClick() {
                    return _this2.handleArticleLinkClicked(articleId);
                  }
                }, anchorTitle);
              }

              var topicIdRegex = /\${topicId=(.*)}/g;
              var topicIdMatches = topicIdRegex.exec(href);
              var topicId = topicIdMatches && topicIdMatches[1] || null;

              if (topicId) {
                return _react.default.createElement(_reactRouterDom.Link, {
                  to: "/topic/".concat(topicId)
                }, anchorTitle);
              }

              if (href && href.charAt(0) === '#') {
                return _react.default.createElement("a", {
                  href: href,
                  onClick: function onClick(event) {
                    // when scrolling to a hash, account for search bar height
                    event.preventDefault();
                    var hashedId = href.split('#')[1];
                    var hashedElement = window.document.getElementById(hashedId);
                    hashedElement.scrollIntoView(true);
                    var scrollable = window.document.getElementsByClassName(_constants.CLASS_APP_CONTAINER)[0];
                    scrollable.scrollTop = scrollable.scrollTop - _styles.default.sizes.search;
                  }
                }, anchorTitle);
              }
            }
          }
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          article = _this$props.article,
          market = _this$props.market;
      var hasError = this.state.hasError;
      this.handleArticleViewed();
      return _react.default.createElement(_react.Fragment, null, !hasError && !article && _react.default.createElement("div", {
        className: "help--article-loading"
      }), !hasError && article && _react.default.createElement(_react.Fragment, null, _react.default.createElement("div", {
        className: "help--article-container"
      }, _react.default.createElement("h1", null, article.title), this.renderArticleFromHTML(article.html)), _react.default.createElement("div", {
        className: "help--article-link-container"
      }, _react.default.createElement("a", {
        className: "help--article-link",
        href: "".concat(_constants.HOST_PATH, "/").concat(article.slug, "-").concat(article.id),
        target: "_blank",
        rel: "noopener noreferrer"
      }, _react.default.createElement(_uxcore.Icon, {
        name: "window"
      }), _react.default.createElement("span", null, "\xA0\xA0"), market === _constants.MARKET_EN_US && _react.default.createElement("span", null, "Open article in new tab")))), hasError && _react.default.createElement("div", {
        className: "help--article-container"
      }, _react.default.createElement("span", {
        className: "help--article-error"
      }, "Oops! There was an error loading this article...")), _react.default.createElement(_Style.default, {
        css: "\n          .help--article-container {\n            padding: 1.5em;\n          }\n\n          .help--article-loading {\n            height: calc(100vh - ".concat(_styles.default.sizes.search, "px);\n          }\n\n          .help--article-link-container {\n            padding: 1.5em;\n          }\n          .help--article-link, .help--article-link:hover {\n            text-decoration: none;\n          }\n        ")
      }));
    }
  }]);

  return Article;
}(_react.PureComponent);

exports.Article = Article;
Article.propTypes = {
  article: _articles.articlePropType,
  articleGet: _propTypes.default.func.isRequired,
  market: _propTypes.default.string,
  match: _propTypes.default.object.isRequired,
  trafficArticleClick: _propTypes.default.func.isRequired,
  trafficArticleView: _propTypes.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var id = ownProps.match.params.id;
  return {
    article: state.articles[id],
    market: state.app.market
  };
};

var mapDispatchToProps = {
  articleGet: _actions.articleGet,
  trafficArticleClick: _actions.trafficArticleClick,
  trafficArticleView: _actions.trafficArticleView
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Article);

exports.default = _default;